<template>
  <div class="feedbackBottom">
    <!-- 暫時關閉 forum 功能 -->
    <!-- <div class="feedback-box"> -->
      <!-- <p>{{$t("love_to_hear_your_thoughts")}}</p> -->
      <!-- <div class="comments" v-if="!isPreview"> -->
        <!-- <component :is="'script'" src="https://c1.ty-cdn.net/-/talkyard-comments.min.js" async defer></component> -->
        <!-- <component :is="'script'">talkyardServerUrl='https://forum.wise-paas.advantech.com';</component> -->
        <!-- You can specify a per page discussion id on the next line, if your URLs might change. -->
        <!-- <div class="talkyard-comments" :data-discussion-id="forumId" style="margin-top: 45px;"> -->
          <!-- <noscript>Please enable Javascript to view comments.</noscript> -->
        <!-- </div> -->
      <!-- </div> -->
    <!-- </div> -->
  </div>
</template>

<script>

export default {
  name: 'feedbackBottom',
  props: {
    forumId: String,
    isPreview: Boolean
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.feedbackBottom {
  .feedback-box {
    border-bottom: solid 1px #c8c8c8;
    p {
      padding: 16px 0;
      line-height: normal;
      margin-block-start: 0;
      margin-block-end: 0;
      font-size: 16px;
      color: #787878;
    }
  }
}
</style>
<style lang="scss">
.talkyard-comments {
  margin-top: 16px !important;
  font-size: 16px;
  color: #787878;
}
</style>
